<template>
  <div class="GG-chart">
    <div style="position: relative; margin: 22px">
      <div
        class="speed speeds-t absolute"
        style="top: -50px; left: 50%; transform: translateX(-50%)"
      >
        {{ speeds[0] }}
      </div>
      <div
        class="speed speeds-r absolute"
        style="
          right: -50px;
          top: 50%;
          transform: translateY(-50%);
          text-align: left;
        "
      >
        {{ speeds[1] }}
      </div>
      <div
        class="speed speeds-b absolute"
        style="bottom: -50px; left: 50%; transform: translateX(-50%)"
      >
        {{ speeds[2] }}
      </div>
      <div
        class="speed speeds-l absolute"
        style="
          left: -50px;
          top: 50%;
          transform: translateY(-50%);
          text-align: right;
        "
      >
        {{ speeds[3] }}
      </div>
      <div
        style="
          border-radius: 50%;
          overflow: hidden;
          box-shadow: rgb(129 150 158 / 80%) 0px 0px 19px 4px;
          border: 1px solid #7ea39c;
        "
        :style="{
          height: chartWidth + 'px',
          width: chartHeight + 'px',
        }"
      >
        <div
          class="tips absolute text-weight-bold"
          :style="{
            zIndex: 2,
            bottom: chartHeight * 0.1 + 'px',
            width: 175 + 'px',
            left: -50 + 'px',
            borderBottom: '1px solid #7ea39c',
            fontSize: 18 + 'px',
          }"
        >
          <div class="absolute" :style="{ top: 5 + 'px' }">0.8G</div>
        </div>
        <Charts :options="optionsACC" ref="chartsACC" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import Charts from "@/components/Charts";
import {
  calculateNewPosition,
  getChartDefaulOpiotnsACC,
  getList,
  getPoints,
} from "./helper";
import { toFixed } from "@/utils/math";
import { getDefaultSeriesData } from "../../helper/ivse";
import { debounce } from "lodash-es";
import { chartHeight, chartWidth } from "./helper";

const emit = defineEmits(["reset"]);

interface Props {
  seriesData: DomianControl.IVSESeriesData;
  notifyData: DomianControl.IVSENotifyData;
}
const props = withDefaults(defineProps<Props>(), {
  seriesData: () => getDefaultSeriesData(),
  notifyData: () => ({} as DomianControl.IVSENotifyData),
});

const optionsACC = ref(getChartDefaulOpiotnsACC());
const speeds = ref([0, 0, 0, 0].map((num) => num.toFixed(1)));
const chartsACC = ref();

const updateOpthons = function (newValue: DomianControl.IVSESeriesData) {
  const { UIRx_ACULatAcc, UIRx_ACULongdAcc } = newValue;
  let x = UIRx_ACULatAcc[UIRx_ACULatAcc.length - 1];
  let y = UIRx_ACULongdAcc[UIRx_ACULongdAcc.length - 1];
  // 保留两位小数
  x = toFixed(x, 2);
  y = toFixed(y, 2);

  const xList = getList(UIRx_ACULatAcc);
  const yList = getList(UIRx_ACULongdAcc);
  const datas = xList.map((x, index) => [x, yList[index]]);

  const points = getPoints(datas);
  const top = y >= 0 ? Math.abs(y) : 0;
  const bottom = y < 0 ? Math.abs(y) : 0;
  const right = x >= 0 ? Math.abs(x) : 0;
  const left = x < 0 ? Math.abs(x) : 0;

  speeds.value = [top, right, bottom, left].map((num) => num.toFixed(1));
  // Reset because there is a bug when the ball gose out of the dispaly range  重置 因为超出显示范围会有 bug
  if (Math.max(top, bottom, right, left) >= 0.9) {
    reset();
  }
  (optionsACC.value.series as any)[0].data = points;

  const { UIRx_BetaObs = 0 } = props.notifyData;

  const [x2, y2] = calculateNewPosition(UIRx_BetaObs);

  (optionsACC.value.series as any)[1].data = [
    {
      name: "Node 1",
      fixed: true,
      value: [0, 0],
    },
    {
      name: "Node 2",
      value: [x2, y2],
      // symbol: "arrow",
      // symbolSize: 20,
      // symbolOffset: [0, -10],
    },
  ];
};

const reset = debounce(() => {
  emit("reset");
}, 500);

watch(
  () => props.seriesData,
  (newValue) => {
    updateOpthons(newValue);
  },
  { deep: true }
);
</script>
<style scoped>
.speed {
  font-weight: 700;
  font-size: 18px;
  padding: 5px;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
}
</style>
